import { formatPropertyStreet } from './property-card.util';

export function buildListingSlug(property: Record<string, unknown>): string {
  const address = property['Address'] as Record<string, unknown> | undefined;
  const parts = [
    formatPropertyStreet(property),
    String(address?.['City'] ?? '').trim(),
    String(address?.['State'] ?? '').trim(),
  ].filter(Boolean);

  const raw = parts.join(' ') || `listing-${String(property['ListingID'] ?? '')}`;
  const slug = raw
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 96);

  return slug || 'listing';
}
